import React from 'react';
import { getFeatureIconDef } from '../utils/featureIconPack';

const ICON_COLOR = '#111827';

export const FeatureGridIcon: React.FC<{ iconKey?: string; size?: number; color?: string }> = ({
  iconKey,
  size = 28,
  color = ICON_COLOR,
}) => {
  const def = getFeatureIconDef(iconKey) || getFeatureIconDef('mouse-pointer-2');
  if (!def) return null;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      dangerouslySetInnerHTML={{ __html: def.paths }}
    />
  );
};
